<nb-card *ngIf="!showDetail" [nbSpinner]="loading" nbSpinnerStatus="info">
  <nb-card-header>
    <div class="form-inline">
      <nb-form-field fullWidth>
        <nb-icon nbPrefix icon="search-outline" pack="eva"></nb-icon>
        <input
          type="text"
          nbInput
          fullWidth
          shape="semi-round"
          class="form-control"
          [(ngModel)]="strSearch"
          (keydown.enter)="onSearch()"
        />
        <button
          nbSuffix
          nbButton
          ghost
          shape="semi-round"
          status="danger"
          size="small"
          (click)="clearSearch()"
        >
          <nb-icon icon="close-outline"></nb-icon>
        </button>
      </nb-form-field>

      <button
        *ngIf="editorGuide"
        nbButton
        outline
        shape="semi-round"
        status="primary"
        size="small"
        (click)="onNew()"
      >
        <span>Thêm mới</span>
      </button>

      <ngx-view-button-export-excel
        *ngIf="editorGuide"
        [fileName]="'announcement'"
        [source]="announcements"
      >
      </ngx-view-button-export-excel>

      <button
        *ngIf="editorGuide"
        nbButton
        ghost
        status="success"
        size="small"
        (click)="downloadTemplate('import-announcement')"
      >
        <nb-icon icon="file-text-outline"></nb-icon>
        Download excel mẫu
      </button>

      <a *ngIf="editorGuide" class="text-primary link">
        <nb-icon icon="file-text-outline"></nb-icon>
        <input type="file" (change)="onFileChange($event)" multiple="false" />
      </a>
    </div>
  </nb-card-header>
  <nb-card-body *ngIf="editorGuide && !importing">
    <div class="table-responsive">
      <ng2-smart-table
        [settings]="settings"
        [source]="source"
        (userRowSelect)="selectedItem($event)"
        (deleteConfirm)="onDeleteConfirm($event)"
      >
      </ng2-smart-table>
      <strong class="text-hint">Tổng số: {{ source.count() }}</strong>
    </div>
  </nb-card-body>

  <nb-card-body *ngIf="!editorGuide || importing">
    <nb-list>
      <nb-list-item
        *ngFor="let item of display | filter: strSearch; let i = index"
        [ngClass]="i % 2 == 0 ? 'content bg1' : 'content bg2'"
      >
        <div>
          <h6 class="text-primary">{{ item.title }}</h6>
          <div class="details">
            {{ item.description }}
          </div>
        </div>
        <button
          nbButton
          shape="round"
          outline
          status="success"
          size="small"
          (click)="viewDetail(item)"
        >
          <nb-icon icon="checkmark-outline"></nb-icon>
        </button>
      </nb-list-item>
    </nb-list>
  </nb-card-body>

  <nb-card-footer *ngIf="editorGuide && importing">
    <button
      nbButton
      hero
      status="primary"
      size="small"
      (click)="uploadAnnouncement()"
    >
      <nb-icon icon="save-outline"></nb-icon>
      Cập nhật
    </button>
  </nb-card-footer>
</nb-card>

<div *ngIf="showDetail">
  <nb-card>
    <nb-card-header>
      <h1 class="text-heading">
        {{ guide.title }}
      </h1>
    </nb-card-header>

    <nb-card-body>
      <div class="details">
        {{ guide.description }}
      </div>

      <ngx-view-gallery
        *ngIf="guide.sourceType == 'images' && guide.imagesUrl.length > 0"
        [imagesUrl]="guide.imagesUrl"
      >
      </ngx-view-gallery>

      <ngx-view-video
        *ngIf="guide.sourceType == 'video' && guide.videoUrl != ''"
        [url]="guide.videoUrl"
      ></ngx-view-video>

      <ngx-view-document
        *ngIf="guide.sourceType == 'document' && guide.content != ''"
        [content]="guide.content"
      >
      </ngx-view-document>
    </nb-card-body>

    <nb-card-footer>
      <button
        nbButton
        ghost
        shape="semi-round"
        status="info"
        size="small"
        (click)="closeDetail()"
      >
        <nb-icon icon="arrow-back"></nb-icon>
        <span>Trở về</span>
      </button>

      <button
        *ngIf="editorGuide"
        nbButton
        outline
        shape="semi-round"
        status="primary"
        size="small"
        (click)="onEdit(guide)"
      >
        <nb-icon icon="edit-2-outline"></nb-icon>
        <span>Chỉnh sửa</span>
      </button>

      <button
        *ngIf="editorGuide"
        nbButton
        outline
        shape="semi-round"
        status="danger"
        size="small"
        (click)="onDelete(guide)"
      >
        <nb-icon icon="trash-2-outline"></nb-icon>
        <span>Xóa</span>
      </button>
    </nb-card-footer>
  </nb-card>
</div>
